<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="name">
          <el-input
            v-model="queryForm.name"
            @keyup.enter.native="query"
            placeholder="用户姓名"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="driverReview">
          <el-select
            v-model="queryForm.driverReview"
            placeholder="驾驶证审核状态"
          >
            <el-option
              v-for="item in drivingState"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="r-20" prop="drivingReview">
          <el-select
            v-model="queryForm.drivingReview"
            placeholder="行驶证审核状态"
          >
            <el-option
              v-for="item in drivingState"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="r-20" prop="queryDate">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="queryForm.queryDate"
            type="date"
            placeholder="注册时间"
          ></el-date-picker>
        </el-form-item>
        <el-button
          v-if="hasPerm('app:maintain:personnel:list')"
          type="primary"
          @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('app:maintain:personnel:list')" @click="reset"
          >取消</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="55"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="用户姓名"
        width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="联系电话"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="registerTime"
        label="注册时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="vinBind" label="绑定状态" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.vinBind == 1" class="btn-red">未绑定</span>
          <span v-else-if="scope.row.vinBind == 2" class="btn-green"
            >已绑定</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="vin" label="绑定车架号" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <div v-show="row.drivingReview == 3">
            {{ row.vin }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="vinBindTime"
        label="绑定时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="plateNum" label="车牌号" width="90">
        <template slot-scope="{ row }">
          <div v-show="row.drivingReview == 3">
            {{ row.plateNum }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="driverReview" label="驾驶证审核" width="96">
        <template slot-scope="scope">
          <span v-if="scope.row.driverReview == 1" class="btn-gray"
            >未提交</span
          >
          <span v-else-if="scope.row.driverReview == 2" class="btn-orange"
            >待审核</span
          >
          <span v-else-if="scope.row.driverReview == 3" class="btn-green"
            >审核通过</span
          >
          <span v-else-if="scope.row.driverReview == 4" class="btn-red"
            >审核拒绝</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="driverReview" label="行驶证审核" width="96">
        <template slot-scope="scope">
          <span v-if="scope.row.drivingReview == 1" class="btn-gray"
            >未提交</span
          >
          <span v-else-if="scope.row.drivingReview == 2" class="btn-orange"
            >待审核</span
          >
          <span v-else-if="scope.row.drivingReview == 3" class="btn-green"
            >审核通过</span
          >
          <span v-else-if="scope.row.drivingReview == 4" class="btn-red"
            >审核拒绝</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="eleLicenseReview" label="电工证审核" width="96">
        <template slot-scope="scope">
          <span v-if="scope.row.eleLicenseReview == 1" class="btn-gray"
            >未提交</span
          >
          <span v-else-if="scope.row.eleLicenseReview == 2" class="btn-orange"
            >待审核</span
          >
          <span v-else-if="scope.row.eleLicenseReview == 3" class="btn-green"
            >审核通过</span
          >
          <span v-else-if="scope.row.eleLicenseReview == 4" class="btn-red"
            >审核拒绝</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="320" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('app:maintain:personnel:review:driver')"
            @click.stop="queryDriverTable(scope.row, 1)"
            >驾驶证审核</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('app:maintain:personnel:review:driver')"
            @click.stop="queryDriverTable(scope.row, 2)"
            >行驶证审核</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('app:maintain:personnel:review:driver')"
            @click.stop="queryDriverTable(scope.row, 5)"
            >电工证审核</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('maintain:personnel:info')"
            @click.stop="getUserInfo(scope.row)"
            >车主详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 车主详情 -->
    <el-dialog
      title="车主详情"
      :visible.sync="infoVisible"
      class="mini-dialog info-box"
    >
      <p class="dialog-title">必填信息</p>
      <div style="padding: 0 60px;margin-bottom:10px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">姓名</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.name) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">性别</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.sex) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">学历</el-col>
            <el-col :span="18">{{
              $judgeEmpty(staffInfo.educationStr)
            }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">身份证</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.numberId) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">联系电话</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.phone) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">所属代维专业</el-col>
            <el-col :span="18">{{
              $judgeEmpty(staffInfo.belongMaintainStr)
            }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">运维公司</el-col>
            <el-col :span="18">{{
              $judgeEmpty(staffInfo.maintainCompany)
            }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">合同到期时间</el-col>
            <el-col :span="18">{{
              $judgeEmpty(staffInfo.contractTime)
            }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">在职状态</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.situation) }}</el-col>
          </el-col>
        </el-row>
      </div>
      <p class="dialog-title">非必填信息</p>
      <div style="padding: 0 60px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">民族</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.nation) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">籍贯</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.hometown) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">家庭住址</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.addr) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">入职时间</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.entryTime) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">具备技能</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.skill) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">岗位职责</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.postDuty) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">购买保险情况</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.insurance) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">备注</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.remark) }}</el-col>
          </el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="infoVisible = false">取 消</el-button>
        <el-button type="primary" @click="infoVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 审核弹窗 -->
    <el-dialog
      :title="reviewTitle + '审核'"
      :visible.sync="reviewVisible"
      class="mini-dialog drivingBox"
    >
      <p class="dialog-title">
        审核状态：<span style="color:#333;font-weight:400">{{
          dialogState
        }}</span>
      </p>
      <p class="dialog-title" v-show="reviewType == 2">
        车牌号：<span style="color:#333;font-weight:400">{{
          audit.plateNum ? audit.plateNum : "-"
        }}</span>
      </p>
      <p class="dialog-title" v-show="reviewType == 2">
        车架号：<span style="color:#333;font-weight:400">{{
          audit.vin ? audit.vin : "-"
        }}</span>
      </p>
      <div v-if="reviewTitle == '行驶证'">
        <p class="dialog-title">车辆照片页</p>
        <div class="imgWrap" style="padding-bottom: 10px">
          <!-- <img :src="carUrl" alt="图片获取失败" /> -->
          <el-image
            style="width: 440px; height: 280px"
            :src="carUrl"
            :preview-src-list="carUrlList"
          >
          </el-image>
        </div>
      </div>
      <p class="dialog-title">{{ reviewTitleFront }}</p>
      <div class="imgWrap" style="padding-bottom: 10px">
        <!-- <img :src="mainPageUrl" alt="图片获取失败" /> -->
        <el-image
          style="width: 440px; height: 280px"
          :src="mainPageUrl"
          :preview-src-list="mainPageUrlList"
        >
        </el-image>
      </div>
      <p class="dialog-title">{{ reviewTitleBack }}</p>
      <div class="imgWrap">
        <!-- <img :src="vicePageUrl" alt="图片获取失败" /> -->
        <el-image
          style="width: 440px; height: 280px"
          :src="vicePageUrl"
          :preview-src-list="vicePageUrlList"
        >
        </el-image>
      </div>
      <span v-if="reviewState == 2" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="reviewSubmit(3)">通 过</el-button>
        <el-button type="danger" @click="reviewSubmit(4)">不通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      carUrlList: [],
      mainPageUrlList: [],
      vicePageUrlList: [],
      drivingState: [
        {
          id: 1,
          label: "未提交",
        },
        {
          id: 2,
          label: "待审核",
        },
        {
          id: 3,
          label: "审核通过",
        },
        {
          id: 4,
          label: "审核拒绝",
        },
      ],
      queryForm: {
        name: "",
        drivingReview: "",
        driverReview: "",
        queryDate: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      tableVal: [],
      tableData: [],
      infoVisible: false,
      staffInfo: [],
      reviewTitle: "驾驶证",
      reviewTitleFront: "驾驶证主页",
      reviewTitleBack: "驾驶证副页",
      reviewVisible: false,
      dialogState: "",
      carUrl: "",
      mainPageUrl: "",
      vicePageUrl: "",
      personnelId: "",
      reviewType: "",
      reviewState: 2,
      audit: {},
    };
  },
  created() {
    this.getAppUserList();
  },
  methods: {
    async getAppUserList() {
      let _this = this;
      let obj = {};
      obj.name = _this.queryForm.name;
      obj.drivingReview = _this.queryForm.drivingReview;
      obj.driverReview = _this.queryForm.driverReview;
      obj.queryDate = _this.queryForm.queryDate;
      obj.limit = _this.limit;
      obj.page = _this.currentPage;
      let { data: res } = await _this.$axios.get(
        "/api/app/maintain/personnel/list",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
    },
    query() {
      this.getAppUserList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getAppUserList();
    },
    //车主详情弹窗内容
    async getUserInfo(rowData) {
      let id = rowData.id;
      //显示弹框
      this.infoVisible = true;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/maintain/personnel/" + id
      );
      if (res.code == 1) {
        _this.staffInfo = {};
        _this.staffInfo = res.data;
        _this.staffInfo.sex = _this.staffInfo.sex == 1 ? "男" : "女";
        if (_this.staffInfo.situation == 1) {
          _this.staffInfo.situation = "在职";
        } else if (_this.staffInfo.situation == 2) {
          _this.staffInfo.situation = "试用期";
        } else if (_this.staffInfo.situation == 3) {
          _this.staffInfo.situation = "离职";
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async queryDriverTable(rowData, type) {
      let _this = this;
      _this.audit = rowData;
      _this.personnelId = rowData.id;
      _this.reviewType = type;
      _this.carUrl = "";
      _this.mainPageUrl = "";
      _this.vicePageUrl = "";
      _this.carUrlList = [];
      _this.mainPageUrlList = [];
      _this.vicePageUrlList = [];
      let state = "";
      if (type == 1) {
        state = rowData.driverReview;
        _this.reviewTitle = "驾驶证";
        _this.reviewTitleFront = "驾驶证主页";
        _this.reviewTitleBack = "驾驶证副页";
        if (state == 1) {
          _this.$message.warning("请先提交驾驶证");
          return;
        }
      } else if (type == 2) {
        state = rowData.drivingReview;
        _this.reviewTitle = "行驶证";
        _this.reviewTitleFront = "行驶证主页";
        _this.reviewTitleBack = "行驶证副页";
        if (state == 1) {
          _this.$message.warning("请先提交行驶证");
          return;
        }
      } else if (type == 5) {
        state = rowData.eleLicenseReview;
        _this.reviewTitle = "电工证";
        _this.reviewTitleFront = "电工证正面";
        _this.reviewTitleBack = "电工证反面";
        if (state == 1) {
          _this.$message.warning("请先提交电工证");
          return;
        }
      }
      _this.reviewState = state;
      if (state == 2) {
        _this.dialogState = "待审核";
      } else if (state == 3) {
        _this.dialogState = "审核通过";
      } else if (state == 4) {
        _this.dialogState = "审核拒绝";
      }
      let { data: res } = await _this.$axios.get(
        "/api/sys/image/list/?belongId=" +
          _this.personnelId +
          "&belongType=" +
          type
      );
      if (res.code == 1) {
        let arr = res.data;
        for (let item in arr) {
          if (arr[item].belongType == type) {
            if (arr[item].imageType == 1) {
              _this.carUrl = arr[item].url;
              _this.carUrlList.push(_this.carUrl);
            } else if (arr[item].imageType == 2) {
              _this.mainPageUrl = arr[item].url;
              _this.mainPageUrlList.push(_this.mainPageUrl);
            } else if (arr[item].imageType == 3) {
              _this.vicePageUrl = arr[item].url;
              _this.vicePageUrlList.push(_this.vicePageUrl);
            }
          }
        }
        _this.$forceUpdate();
        _this.reviewVisible = true;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async reviewSubmit(reviewStatus) {
      let _this = this;
      if (_this.reviewType == 5) {
        _this.reviewType = 3;
      }
      let parm = {
        reviewStatus: reviewStatus,
        personnelId: _this.personnelId,
        reviewType: _this.reviewType,
      };
      let { data: res } = await _this.$axios.patch(
        "/api/app/maintain/personnel",
        parm
      );
      if (res.code == 1) {
        _this.$message.success("操作成功");
        _this.getAppUserList();
      } else {
        _this.$message.warning(res.msg);
      }
      _this.reviewVisible = false;
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val;
    },
    handleClickTableRow(row, event, column) {
      console.log(row);
      console.log(column);
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getAppUserList();
    },
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  padding: 0 20px;
  background: #fff;
}
// 模态框样式设置
.info-box /deep/ .el-dialog {
  width: 900px;
  height: 540px;
}
.info-box /deep/ .el-dialog__body {
  color: #333;
}
/deep/ .el-dialog__body {
  padding: 18px;
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.dialog-label {
  font-weight: bold;
}
.info-box /deep/ .el-row {
  height: 34px;
  line-height: 34px;
}
.drivingBox /deep/ .el-dialog {
  width: 600px;
}
.imgWrap {
  padding: 0 60px;
}
.imgWrap img {
  width: 440px;
  height: 280px;
}
</style>
